module["exports"] = [
  "MBA",
  "Phd."
];
